/**
 * Context submission API service
 */

import apiClient from './api';
import { BusinessContext, AnalysisSession } from '../types/session';

export const contextService = {
  /**
   * Submit business context for a session
   */
  async submitContext(sessionId: string, context: BusinessContext): Promise<AnalysisSession> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/context`, context);
    return response.data;
  },
};

export default contextService;
